(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["address-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-address-fields')) {
    customElements.define(
      'sx-address-fields',
      class extends HTMLElement {
        connectedCallback() {
          this.country = this.querySelector('[data-country-select]');
          this.province = this.querySelector('[data-province-select]');
          this.provinceField = this.querySelector('[data-province-field]');
          if (!this.country || !this.province) return;
          const defaultCountry = this.country.dataset.default;
          const match = Array.from(this.country.options).find(
            (option) => option.value === defaultCountry || option.textContent.trim() === defaultCountry,
          );
          if (match) this.country.value = match.value;
          this.country.addEventListener('change', () => this.renderProvinces(''));
          this.renderProvinces(this.province.dataset.default || '');
        }

        renderProvinces(selected) {
          const option = this.country.options[this.country.selectedIndex];
          let provinces = [];
          try {
            provinces = JSON.parse(option?.dataset.provinces || '[]');
          } catch (error) {
            provinces = [];
          }
          this.province.replaceChildren(
            ...provinces.map(([value, label]) => {
              const item = new Option(label, value);
              item.selected = value === selected || label === selected;
              return item;
            }),
          );
          const hasProvinces = provinces.length > 0;
          this.provinceField.hidden = !hasProvinces;
          this.province.disabled = !hasProvinces;
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-cart-coupon')) {
    customElements.define(
      'sx-cart-coupon',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.form = this.querySelector('[data-coupon-form]');
          this.input = this.querySelector('input[name="discount"]');
          this.button = this.querySelector('[data-coupon-apply]');
          this.input?.addEventListener('input', () => {
            this.button.disabled = !this.input.value.trim();
            this.input.removeAttribute('aria-invalid');
          });
          this.form?.addEventListener('submit', (event) => {
            event.preventDefault();
            const code = this.input.value.trim();
            if (code) this.apply(code);
          });
          this.addEventListener('click', (event) => {
            const remove = event.target.closest('[data-coupon-remove]');
            if (remove) this.remove(remove.dataset.couponRemove);
          });
        }

        codes() {
          return (this.dataset.codes || '')
            .split(',')
            .map((code) => code.trim())
            .filter(Boolean);
        }

        showError(message, code) {
          const error = this.querySelector('[data-coupon-error]');
          if (!error) return;
          error.textContent = message;
          error.hidden = false;
          if (this.input) {
            if (code) this.input.value = code;
            this.input.setAttribute('aria-invalid', 'true');
            if (this.button) this.button.disabled = !this.input.value.trim();
          }
        }

        setBusy(busy) {
          this.querySelectorAll('button').forEach((button) => {
            button.disabled = busy || (button === this.button && !this.input?.value.trim());
          });
          this.setAttribute('aria-busy', String(busy));
        }

        report(message, code) {
          const targets = this.isConnected ? [this] : Array.from(document.querySelectorAll('sx-cart-coupon'));
          targets.forEach((el) => el.showError?.(message, code));
        }

        async send(codes, attemptedCode) {
          const theme = window.SxTheme;
          const errorText = this.dataset.error;
          this.setBusy(true);
          try {
            const cart = await theme.cart.update({ discount: codes.join(',') });
            if (!attemptedCode) return;
            const match = (cart.discount_codes || []).find((entry) => String(entry.code).toLowerCase() === attemptedCode.toLowerCase());
            if (!match || !match.applicable) this.report(errorText, attemptedCode);
          } catch (failure) {
            this.report(failure.data?.description || failure.data?.message || errorText, attemptedCode);
          } finally {
            if (this.isConnected) this.setBusy(false);
          }
        }

        apply(code) {
          const codes = this.codes().filter((existing) => existing.toLowerCase() !== code.toLowerCase());
          this.send([...codes, code], code);
        }

        remove(code) {
          this.send(this.codes().filter((existing) => existing !== code));
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-line"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-cart-lines')) {
    const QTY_DEBOUNCE_MS = 300;

    customElements.define(
      'sx-cart-lines',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.addEventListener('change', (event) => {
            const input = event.target.closest('.sx-qty__input');
            const line = input?.closest('.sx-line');
            if (!line) return;
            window.clearTimeout(line.qtyTimer);
            line.qtyTimer = window.setTimeout(() => this.update(line, Math.max(0, Math.floor(Number(input.value) || 0))), QTY_DEBOUNCE_MS);
          });
          this.addEventListener('click', (event) => {
            const remove = event.target.closest('[data-line-remove]');
            const line = remove?.closest('.sx-line');
            if (!line) return;
            event.preventDefault();
            this.update(line, 0);
          });
        }

        async update(line, quantity) {
          const theme = window.SxTheme;
          if (!theme?.cart) return;
          if (String(quantity) === line.dataset.quantity) return;
          const error = line.querySelector('[data-line-error]');
          line.classList.add('is-busy');
          line.setAttribute('aria-busy', 'true');
          if (error) error.hidden = true;
          try {
            await theme.cart.change(Number(line.dataset.line), quantity);
          } catch (failure) {
            const input = line.querySelector('.sx-qty__input');
            if (input) {
              input.value = line.dataset.quantity;
              input.closest('sx-quantity')?.clamp?.();
            }
            if (error) {
              error.textContent = failure.data?.description || failure.data?.message || this.dataset.error || failure.message;
              error.hidden = false;
            }
          } finally {
            if (line.isConnected) {
              line.classList.remove('is-busy');
              line.removeAttribute('aria-busy');
            }
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-cart-upsell')) {
    const cache = new Map();
    const IMAGE_WIDTH = 160;

    const fetchRecommendations = (url, productId, intent, limit) => {
      const key = `${productId}|${intent}|${limit}`;
      if (!cache.has(key)) {
        const params = new URLSearchParams({ product_id: productId, limit: String(limit), intent });
        const request = fetch(`${url}?${params.toString()}`, { headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.json();
          })
          .then((data) => data.products || [])
          .catch((error) => {
            cache.delete(key);
            throw error;
          });
        cache.set(key, request);
      }
      return cache.get(key);
    };

    const imageUrl = (src) => {
      if (!src) return '';
      try {
        const url = new URL(src.startsWith('//') ? `https:${src}` : src, window.location.origin);
        url.searchParams.set('width', String(IMAGE_WIDTH));
        return url.toString();
      } catch (error) {
        return src;
      }
    };

    customElements.define(
      'sx-cart-upsell',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.list = this.querySelector('[data-upsell-list]');
          this.template = this.querySelector('template[data-upsell-row]');
          if (!this.list || !this.template) return;
          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-add]');
            if (button) this.add(button);
          });
          /* The merchant's own list is already rendered server-side. */
          if (!this.hasAttribute('data-manual') && this.dataset.productId) this.load();
        }

        async load() {
          const limit = Number(this.dataset.limit) || 3;
          const exclude = new Set((this.dataset.exclude || '').split(',').filter(Boolean).map(Number));
          const fetchLimit = Math.min(10, limit + exclude.size + 2);
          const intents = this.dataset.intent === 'related' ? ['related'] : [this.dataset.intent, 'related'];
          let products = [];
          for (const intent of intents) {
            try {
              const result = await fetchRecommendations(this.dataset.url, this.dataset.productId, intent, fetchLimit);
              products = result.filter((product) => product.available && !exclude.has(Number(product.id)));
            } catch (error) {
              products = [];
            }
            if (products.length) break;
          }
          if (!this.isConnected || !products.length) return;
          this.list.replaceChildren(...products.slice(0, limit).map((product) => this.row(product)));
          this.hidden = false;
        }

        row(product) {
          const theme = window.SxTheme;
          const fragment = this.template.content.cloneNode(true);
          const row = fragment.querySelector('.sx-upsell__row');
          row.querySelectorAll('[data-href]').forEach((link) => {
            link.href = product.url;
          });
          row.querySelector('[data-name]').textContent = product.title;
          const image = row.querySelector('img');
          const src = imageUrl(product.featured_image);
          if (src) image.src = src;
          else image.remove();
          const variant = (product.variants || []).find((item) => item.available) || (product.variants || [])[0];
          const price = variant ? variant.price : product.price;
          const compare = variant ? variant.compare_at_price : product.compare_at_price;
          row.querySelector('[data-final]').textContent = theme.formatMoney(price);
          if (compare && compare > price) {
            const compareEl = row.querySelector('[data-compare]');
            compareEl.textContent = theme.formatMoney(compare);
            compareEl.hidden = false;
            row.querySelector('[data-price]').classList.add('sx-price--sale');
          }
          const tag = (this.dataset.personalizationTag || '').trim().toLowerCase();
          const tags = (product.tags || []).map((item) => String(item).toLowerCase());
          const needsOptions = (product.variants || []).length > 1 || product.requires_selling_plan || (tag && tags.includes(tag));
          if (needsOptions || !variant) {
            const choose = row.querySelector('[data-choose]');
            choose.href = product.url;
            choose.hidden = false;
          } else {
            const add = row.querySelector('[data-add]');
            add.dataset.variantId = String(variant.id);
            add.hidden = false;
          }
          return fragment;
        }

        async add(button) {
          const theme = window.SxTheme;
          const row = button.closest('.sx-upsell__row');
          const error = row.querySelector('[data-row-error]');
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
          error.hidden = true;
          try {
            await theme.cart.add([{ id: Number(button.dataset.variantId), quantity: 1 }]);
          } catch (failure) {
            if (!button.isConnected) return;
            error.textContent = failure.data?.description || failure.data?.message || this.dataset.error;
            error.hidden = false;
          } finally {
            if (button.isConnected) {
              button.removeAttribute('aria-busy');
              button.disabled = false;
            }
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-drawer')) {
    const CLOSE_DELAY_MS = 400;

    const focusKey = (el) => {
      const line = el.closest('[data-line-key]');
      const own = el.dataset.step ? `step${el.dataset.step}` : el.getAttribute('name') || el.getAttribute('data-focus') || el.className;
      return { line: line ? line.dataset.lineKey : '', own };
    };

    customElements.define(
      'sx-drawer',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector(':scope > dialog');
          if (!this.dialog || this.bound) return;
          this.bound = true;
          this.dialog.addEventListener('click', (event) => {
            if (!event.target.closest('[data-drawer-close]')) return;
            event.preventDefault();
            this.close();
          });
          this.dialog.addEventListener('cancel', (event) => {
            event.preventDefault();
            this.close();
          });
          this.dialog.addEventListener('focusin', (event) => {
            if (event.target !== this.dialog) this.lastFocus = focusKey(event.target);
          });
          this.onCartUpdated = () => this.restoreFocus();
          document.addEventListener('sx:cart-updated', this.onCartUpdated);
        }

        disconnectedCallback() {
          document.removeEventListener('sx:cart-updated', this.onCartUpdated);
          this.bound = false;
          if (this.dialog && this.dialog.open) this.finish(false);
        }

        get isOpen() {
          return Boolean(this.dialog && this.dialog.open && !this.closing);
        }

        syncTriggers(expanded) {
          document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach((el) => el.setAttribute('aria-expanded', String(expanded)));
        }

        open() {
          const theme = window.SxTheme;
          if (!this.dialog) return;
          if (this.dialog.open) {
            if (this.closing) {
              window.clearTimeout(this.closeTimer);
              this.closing = false;
              this.dialog.classList.add('is-open');
            }
            return;
          }
          this.dialog.showModal();
          void this.dialog.offsetWidth;
          this.dialog.classList.add('is-open');
          theme.lockScroll();
          this.release = theme.trapFocus(this.dialog);
          this.syncTriggers(true);
          this.dispatchEvent(new CustomEvent('sx:drawer-open', { bubbles: true }));
        }

        close(options = {}) {
          if (!this.dialog || !this.dialog.open || this.closing) return;
          this.closing = true;
          this.dialog.classList.remove('is-open');
          const reduced = window.SxTheme.reducedMotion();
          const delay = options.immediate || reduced ? 0 : Number(this.dataset.closeDelay ?? CLOSE_DELAY_MS);
          if (delay === 0) {
            this.finish();
            return;
          }
          this.closeTimer = window.setTimeout(() => this.finish(), delay);
        }

        finish(restore = true) {
          window.clearTimeout(this.closeTimer);
          this.closing = false;
          this.dialog.classList.remove('is-open');
          if (this.dialog.open) this.dialog.close();
          window.SxTheme.unlockScroll();
          const release = this.release;
          this.release = null;
          if (release && restore) release();
          this.syncTriggers(false);
          this.dispatchEvent(new CustomEvent('sx:drawer-close', { bubbles: true }));
        }

        restoreFocus() {
          if (!this.isOpen) return;
          const active = document.activeElement;
          if (active && active !== this.dialog && this.dialog.contains(active)) return;
          let target = null;
          if (this.lastFocus) {
            const scope = this.lastFocus.line
              ? this.dialog.querySelector(`[data-line-key="${CSS.escape(this.lastFocus.line)}"]`)
              : this.dialog;
            if (scope) {
              target = Array.from(scope.querySelectorAll('a[href], button, input, textarea, select')).find((el) => {
                const key = focusKey(el);
                return key.own === this.lastFocus.own && !el.disabled;
              });
            }
          }
          target = target || this.dialog.querySelector('[data-drawer-close]:not(.sx-drawer__backdrop)');
          if (target) target.focus({ preventScroll: true });
        }
      },
    );

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-drawer-open]');
      if (!trigger) return;
      const drawer = document.getElementById(trigger.dataset.drawerOpen);
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      drawer.open(trigger);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-newsletter')) {
    customElements.define(
      'sx-newsletter',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.closest('form');
          this.email = this.querySelector('input[type="email"]');
          this.consent = this.querySelector('input[type="checkbox"]');
          if (!this.form || !this.email || !this.consent || this.bound) return;
          this.bound = true;
          this.emailError = this.querySelector('[data-email-error]');
          this.consentError = this.querySelector('[data-consent-error]');
          this.consentLabel = this.querySelector('[data-consent-label]');

          this.form.addEventListener('submit', (event) => {
            const emailOk = this.email.checkValidity();
            const consentOk = this.consent.checked;
            this.setEmailError(!emailOk);
            this.setConsentError(!consentOk);
            if (emailOk && consentOk) {
              this.dispatchEvent(new CustomEvent('sx:newsletter-submit', { bubbles: true }));
              return;
            }
            event.preventDefault();
            (emailOk ? this.consent : this.email).focus();
          });
          this.email.addEventListener('input', () => {
            if (this.email.checkValidity()) this.setEmailError(false);
          });
          this.consent.addEventListener('change', () => {
            if (this.consent.checked) this.setConsentError(false);
          });
        }

        setEmailError(invalid) {
          if (!this.emailError) return;
          this.emailError.hidden = !invalid;
          if (invalid) {
            this.email.setAttribute('aria-invalid', 'true');
            this.email.setAttribute('aria-describedby', this.emailError.id);
          } else {
            this.email.removeAttribute('aria-invalid');
            this.email.removeAttribute('aria-describedby');
          }
        }

        setConsentError(invalid) {
          if (this.consentError) this.consentError.hidden = !invalid;
          this.consentLabel?.classList.toggle('has-error', invalid);
          this.consent.setAttribute('aria-invalid', String(invalid));
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-quick-add')) {
    customElements.define(
      'sx-quick-add',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.button?.addEventListener('click', () => this.add());
        }

        async add() {
          const theme = window.SxTheme;
          if (!theme?.cart || this.button.getAttribute('aria-busy') === 'true') return;
          this.button.setAttribute('aria-busy', 'true');
          try {
            await theme.cart.add([{ id: Number(this.button.dataset.variantId), quantity: 1 }]);
            theme.cart.afterAdd();
          } catch (error) {
            window.alert(error.message);
          } finally {
            this.button.removeAttribute('aria-busy');
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-product-gallery')) {
    customElements.define(
      'sx-product-gallery',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;
          this.track = this.querySelector('[data-gal-track]');
          this.slides = Array.from(this.querySelectorAll('[data-gal-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-gal-dot]'));
          this.thumbs = Array.from(this.querySelectorAll('[data-gal-thumb]'));
          this.modal = this.querySelector('sx-modal');
          this.active = 0;
          this.lightboxIndex = 0;
          this.lightboxItems = Array.from(this.querySelectorAll('[data-lightbox-item]'));
          this.lightboxTrack = this.querySelector('[data-lightbox-track]');
          this.lightboxCounter = this.querySelector('[data-lightbox-counter]');
          this.lightboxThumbs = Array.from(this.querySelectorAll('[data-lightbox-thumb]'));
          this.zoomButton = this.querySelector('[data-lightbox-zoom]');
          this.zoomLabel = this.querySelector('[data-lightbox-zoom-label]');
          this.lightboxTrack?.addEventListener('scroll', () => this.onLightboxScroll(), { passive: true });
          this.lightboxThumbs.forEach((thumb) =>
            thumb.addEventListener('click', () => this.showLightbox(Number(thumb.dataset.lightboxThumb))),
          );
          this.zoomButton?.addEventListener('click', () => this.toggleZoom());
          this.lightboxItems.forEach((item) =>
            item.addEventListener('click', (event) => {
              /* A drag to pan must not be read as a tap to zoom out. */
              if (item.classList.contains('is-zoomed') && this.panned) return;
              this.toggleZoom(event);
            }),
          );
          this.lightboxTrack?.addEventListener('pointerdown', () => {
            this.panned = false;
          });
          this.lightboxTrack?.addEventListener('pointermove', (event) => {
            if (event.buttons || event.pointerType === 'touch') this.panned = true;
          });
          this.modal?.querySelectorAll('[data-modal-close]').forEach((button) => button.addEventListener('click', () => this.resetZoom()));

          this.querySelector('[data-gal-prev]')?.addEventListener('click', () => this.goTo(this.active - 1));
          this.querySelector('[data-gal-next]')?.addEventListener('click', () => this.goTo(this.active + 1));
          this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.galThumb))));
          this.querySelectorAll('[data-gal-zoom]').forEach((button) =>
            button.addEventListener('click', () => this.openLightbox(button.dataset.galZoom, button)),
          );
          this.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => this.showLightbox(this.lightboxIndex - 1));
          this.querySelector('[data-lightbox-next]')?.addEventListener('click', () => this.showLightbox(this.lightboxIndex + 1));
          this.modal?.querySelector('dialog')?.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.showLightbox(this.lightboxIndex - 1);
            if (event.key === 'ArrowRight') this.showLightbox(this.lightboxIndex + 1);
          });

          this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
          this.querySelector('.sx-gal__stage').addEventListener('keydown', (event) => {
            if (event.target.closest('model-viewer, iframe, video')) return;
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.goTo(this.active - 1, true);
            } else if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.goTo(this.active + 1, true);
            }
          });

          this.onVariant = (event) => {
            const detail = event.detail || {};
            if (detail.sectionId !== this.dataset.sectionId || !detail.variant?.featured_media) return;
            const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(detail.variant.featured_media.id));
            if (index >= 0) this.goTo(index);
          };
          document.addEventListener(window.SxTheme?.events?.variantChanged || 'sx:variant-changed', this.onVariant);

          const start = Number(this.dataset.start || 0);
          if (start > 0) requestAnimationFrame(() => this.goTo(start, false, 'auto'));
          if (this.querySelector('[data-gal-has-model]')) this.loadModels();
        }

        disconnectedCallback() {
          document.removeEventListener(window.SxTheme?.events?.variantChanged || 'sx:variant-changed', this.onVariant);
          this.ready = false;
        }

        get isScroller() {
          return this.track.scrollWidth > this.track.clientWidth + 2;
        }

        goTo(index, focusSlide = false, behavior) {
          const count = this.slides.length;
          if (!count) return;
          const next = (index + count) % count;
          this.setActive(next);
          if (this.isScroller) {
            const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.track.scrollTo({ left: this.track.clientWidth * next, behavior: behavior || (reduced ? 'auto' : 'smooth') });
          }
          if (focusSlide) this.slides[next].querySelector('button:not([disabled])')?.focus({ preventScroll: true });
        }

        onScroll() {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            if (!this.isScroller || !this.track.clientWidth) return;
            const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (index !== this.active) this.setActive(index);
          });
        }

        setActive(index) {
          this.active = index;
          this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          this.thumbs.forEach((thumb, i) => {
            const current = i === index;
            thumb.classList.toggle('is-active', current);
            thumb.setAttribute('aria-current', String(current));
          });
          this.slides.forEach((slide, i) => {
            const video = slide.querySelector('video');
            if (!video) return;
            if (i === index) video.play?.().catch(() => {});
            else if (this.isScroller) video.pause?.();
          });
        }

        openLightbox(mediaId, opener) {
          if (!this.modal || typeof this.modal.open !== 'function') return;
          const index = this.lightboxItems.findIndex((item) => item.dataset.lightboxItem === String(mediaId));
          this.modal.open(opener);
          /* The dialog has no layout until it is open, so jump without animation on the next frame. */
          requestAnimationFrame(() => this.showLightbox(index < 0 ? 0 : index, 'auto'));
        }

        /* Zooms the slide that was tapped, centred on the tap point; called with no event (the
           toolbar button) it centres the image instead. */
        toggleZoom(event) {
          const item = this.lightboxItems[this.lightboxIndex];
          if (!item) return;
          const zoomed = !item.classList.contains('is-zoomed');
          this.resetZoom();
          if (!zoomed) return;
          item.classList.add('is-zoomed');
          this.lightboxTrack?.classList.add('is-zoomed');
          this.zoomButton?.setAttribute('aria-pressed', 'true');
          if (this.zoomLabel) this.zoomLabel.textContent = this.zoomButton.dataset.labelOut || this.zoomLabel.textContent;
          const rect = item.getBoundingClientRect();
          const x = event ? (event.clientX - rect.left) / rect.width : 0.5;
          const y = event ? (event.clientY - rect.top) / rect.height : 0.5;
          /* Reading scrollWidth flushes layout for the class just added, so the scroll can be set
             straight away rather than a frame later (rAF is throttled in background tabs). */
          item.scrollLeft = x * (item.scrollWidth - item.clientWidth);
          item.scrollTop = y * (item.scrollHeight - item.clientHeight);
        }

        resetZoom() {
          this.lightboxItems.forEach((item) => item.classList.remove('is-zoomed'));
          this.lightboxTrack?.classList.remove('is-zoomed');
          this.zoomButton?.setAttribute('aria-pressed', 'false');
          if (this.zoomLabel) this.zoomLabel.textContent = this.zoomButton?.dataset.labelIn || this.zoomLabel.textContent;
        }

        showLightbox(index, behavior) {
          const count = this.lightboxItems.length;
          if (!count) return;
          this.resetZoom();
          this.lightboxIndex = (index + count) % count;
          const target = this.lightboxItems[this.lightboxIndex];
          target.querySelector('img')?.setAttribute('loading', 'eager');
          if (this.lightboxTrack) {
            this.lightboxTrack.scrollTo({
              left: target.offsetLeft - this.lightboxTrack.offsetLeft,
              behavior: behavior || (window.SxTheme?.reducedMotion() ? 'auto' : 'smooth'),
            });
          }
          this.updateLightboxCounter();
        }

        onLightboxScroll() {
          if (!this.lightboxTrack) return;
          const width = this.lightboxTrack.clientWidth;
          if (!width) return;
          const index = Math.min(Math.max(Math.round(this.lightboxTrack.scrollLeft / width), 0), this.lightboxItems.length - 1);
          if (index === this.lightboxIndex) return;
          this.lightboxIndex = index;
          this.lightboxItems[index]?.querySelector('img')?.setAttribute('loading', 'eager');
          this.updateLightboxCounter();
        }

        updateLightboxCounter() {
          if (this.lightboxCounter) {
            this.lightboxCounter.textContent = String(this.lightboxIndex + 1) + ' / ' + String(this.lightboxItems.length);
          }
          this.lightboxThumbs.forEach((thumb, index) => {
            const active = index === this.lightboxIndex;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-current', String(active));
            if (active) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          });
        }

        loadModels() {
          const init = () => {
            if (!window.Shopify?.loadFeatures) return;
            window.Shopify.loadFeatures([
              {
                name: 'model-viewer-ui',
                version: '1.0',
                onLoad: (errors) => {
                  if (errors || !window.Shopify.ModelViewerUI) return;
                  this.querySelectorAll('model-viewer').forEach((viewer) => new window.Shopify.ModelViewerUI(viewer));
                },
              },
            ]);
          };
          if (document.readyState === 'complete') init();
          else window.addEventListener('load', init, { once: true });
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-listing-element"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-listing')) {
    const COLLAPSE_AFTER = 8;

    const stripSectionId = (query) => {
      const params = new URLSearchParams(query);
      params.delete('section_id');
      return params.toString();
    };

    const parseDecimal = (raw) => {
      const normalized = String(raw || '').trim().replace(/\s/g, '').replace(',', '.');
      if (!normalized) return undefined;
      const value = Number(normalized);
      return Number.isFinite(value) ? value : undefined;
    };

    customElements.define(
      'sx-listing',
      class SxListing extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.mode = this.dataset.mode;
          this.cache = new Map();
          this.lastQuery = stripSectionId(window.location.search);

          this.handleClick = this.handleClick.bind(this);
          this.handleChange = this.handleChange.bind(this);
          this.handleSubmit = this.handleSubmit.bind(this);
          this.handleInput = this.handleInput.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handlePopState = this.handlePopState.bind(this);

          this.addEventListener('click', this.handleClick);
          this.addEventListener('change', this.handleChange);
          this.addEventListener('submit', this.handleSubmit);
          this.addEventListener('input', this.handleInput);
          this.addEventListener('keydown', this.handleKeydown);
          window.addEventListener('popstate', this.handlePopState);

          this.sanitizeLinks();
          this.setupInfinite();
        }

        disconnectedCallback() {
          window.removeEventListener('popstate', this.handlePopState);
          this.observer?.disconnect();
        }

        get theme() {
          return window.SxTheme || {};
        }

        /* ---------- Events ---------- */
        handleClick(event) {
          const target = event.target;

          if (target.closest('[data-listing-apply]')) {
            this.closeDrawer();
            return;
          }

          const toggle = target.closest('.sx-filter-group__toggle');
          if (toggle) {
            const group = toggle.closest('.sx-filter-group');
            this.setGroup(group, toggle.getAttribute('aria-expanded') !== 'true');
            return;
          }

          const more = target.closest('[data-filter-more]');
          if (more) {
            more.setAttribute('aria-expanded', String(more.getAttribute('aria-expanded') !== 'true'));
            this.refreshValues(more.closest('[data-filter-values]'));
            return;
          }

          const density = target.closest('[data-listing-density], [data-listing-density-mobile]');
          if (density) {
            this.setDensity(density);
            return;
          }

          const loadMore = target.closest('a[data-listing-more]');
          if (loadMore) {
            event.preventDefault();
            this.loadMore(loadMore);
            return;
          }

          const link = target.closest('a[data-listing-link]');
          if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
            event.preventDefault();
            const url = new URL(link.href, window.location.href);
            const scrollTop = link.hasAttribute('data-scroll-top') || this.mode === 'pages';
            this.render(url.search.slice(1), { scrollTop });
          }
        }

        handleChange(event) {
          const target = event.target;
          if (target.matches('[data-listing-sort]')) {
            const params = new URLSearchParams(this.lastQuery);
            params.set('sort_by', target.value);
            params.delete('page');
            this.render(params.toString(), { scrollTop: this.mode === 'pages' });
            return;
          }
          if (target.matches('.sx-filter-check__input')) {
            const label = target.closest('label');
            label?.classList.toggle('is-selected', target.checked);
            const form = target.closest('[data-listing-form]');
            if (form) this.render(this.formQuery(form), { scrollTop: this.mode === 'pages' && !this.drawerOpen });
          }
        }

        handleSubmit(event) {
          const form = event.target.closest('[data-listing-form]');
          if (!form) return;
          event.preventDefault();
          form.querySelectorAll('[data-filter-range]').forEach((range) => this.normalizeRange(range));
          this.render(this.formQuery(form), { scrollTop: this.mode === 'pages' && !this.drawerOpen });
        }

        handleInput(event) {
          if (event.target.matches('[data-filter-search]')) {
            this.refreshValues(event.target.closest('[data-filter-values]'));
          }
        }

        handleKeydown(event) {
          if (event.key === 'Enter' && event.target.matches('[data-filter-search]')) {
            event.preventDefault();
          }
        }

        handlePopState() {
          const query = stripSectionId(window.location.search);
          if (query === this.lastQuery) return;
          this.render(query, { push: false });
        }

        /* ---------- Filter UI ---------- */
        setGroup(group, open) {
          if (!group) return;
          const toggle = group.querySelector('.sx-filter-group__toggle');
          const panel = group.querySelector('.sx-filter-group__panel');
          group.classList.toggle('is-open', open);
          toggle?.setAttribute('aria-expanded', String(open));
          if (panel) panel.hidden = !open;
        }

        refreshValues(wrap) {
          if (!wrap) return;
          const search = wrap.querySelector('[data-filter-search]');
          const more = wrap.querySelector('[data-filter-more]');
          const needle = (search?.value || '').trim().toLocaleLowerCase('tr');
          const expanded = more?.getAttribute('aria-expanded') === 'true';
          wrap.querySelectorAll('li[data-filter-name]').forEach((item, index) => {
            const name = (item.dataset.filterName || '').toLocaleLowerCase('tr');
            const matches = !needle || name.includes(needle);
            const collapsed = !needle && more && !expanded && index >= COLLAPSE_AFTER;
            item.hidden = !matches || Boolean(collapsed);
          });
          if (more) more.hidden = Boolean(needle);
        }

        normalizeRange(range) {
          const fromInput = range.querySelector('[data-range-from]');
          const toInput = range.querySelector('[data-range-to]');
          if (!fromInput || !toInput) return;
          const minBound = Number(range.dataset.min) || 0;
          const maxBound = Number(range.dataset.max) || 0;
          const parsedFrom = parseDecimal(fromInput.value);
          const parsedTo = parseDecimal(toInput.value);

          if (parsedFrom === undefined && parsedTo === undefined) {
            fromInput.value = '';
            toInput.value = '';
            return;
          }

          const clamp = (value) => Math.min(maxBound, Math.max(minBound, value));
          let from = clamp(parsedFrom ?? minBound);
          let to = clamp(parsedTo ?? maxBound);
          if (from > to) [from, to] = [to, from];

          if (from <= minBound && to >= maxBound) {
            fromInput.value = '';
            toInput.value = '';
            return;
          }
          fromInput.value = from > minBound ? String(from) : '';
          toInput.value = to < maxBound ? String(to) : '';
        }

        formQuery(form) {
          const params = new URLSearchParams();
          new FormData(form).forEach((value, key) => {
            const text = String(value).trim();
            if (text !== '') params.append(key, text);
          });
          const sort = this.querySelector('[data-listing-sort]');
          if (sort) params.set('sort_by', sort.value);
          params.delete('page');
          return params.toString();
        }

        setDensity(button) {
          const isMobile = button.hasAttribute('data-listing-density-mobile');
          const value = isMobile ? button.dataset.listingDensityMobile : button.dataset.listingDensity;
          const selector = isMobile ? '[data-listing-density-mobile]' : '[data-listing-density]';
          this.querySelectorAll(selector).forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          this.style.setProperty(isMobile ? '--cols-m' : '--cols', value);
        }

        /* ---------- Drawer (snippets/drawer.liquid <sx-drawer>) ---------- */
        get drawer() {
          return this.querySelector('sx-drawer');
        }

        get drawerOpen() {
          return Boolean(this.drawer?.isOpen);
        }

        closeDrawer() {
          if (this.drawerOpen) this.drawer.close();
        }

        /* ---------- Rendering ---------- */
        sectionUrl(query) {
          const params = new URLSearchParams(stripSectionId(query));
          params.set('section_id', this.sectionId);
          return `${window.location.pathname}?${params.toString()}`;
        }

        setLoading(isLoading) {
          const results = this.querySelector('[data-listing-results]');
          results?.classList.toggle('is-loading', isLoading);
          results?.setAttribute('aria-busy', String(isLoading));
          this.querySelectorAll('[data-listing-apply]').forEach((button) => {
            button.classList.toggle('is-loading', isLoading);
            const spinner = button.querySelector('.sx-spinner');
            if (spinner) spinner.hidden = !isLoading;
          });
        }

        async fetchSection(query, signal) {
          const url = this.sectionUrl(query);
          if (this.cache.has(url)) return this.cache.get(url);
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          this.cache.set(url, html);
          return html;
        }

        async render(query, { push = true, scrollTop = false } = {}) {
          const cleanQuery = stripSectionId(query);
          this.controller?.abort();
          const controller = new AbortController();
          this.controller = controller;
          this.setLoading(true);
          try {
            const html = await this.fetchSection(cleanQuery, controller.signal);
            this.applyHtml(html);
            this.lastQuery = cleanQuery;
            if (push) {
              const nextUrl = `${window.location.pathname}${cleanQuery ? `?${cleanQuery}` : ''}`;
              window.history.pushState({ sxListing: this.sectionId }, '', nextUrl);
            }
            const sort = this.querySelector('[data-listing-sort]');
            const sortValue = new URLSearchParams(cleanQuery).get('sort_by');
            if (sort && sortValue) sort.value = sortValue;
            if (scrollTop) this.scrollToTop();
          } catch (error) {
            if (error.name === 'AbortError') return;
            window.location.assign(`${window.location.pathname}${cleanQuery ? `?${cleanQuery}` : ''}`);
          } finally {
            if (this.controller === controller) this.setLoading(false);
          }
        }

        applyHtml(html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const source = doc.querySelector('sx-listing');
          if (!source) throw new Error('Listing markup missing');

          const state = this.captureState();
          const parts = Array.from(this.querySelectorAll('[data-listing-part]')).filter(
            (part) => !part.parentElement.closest('[data-listing-part]'),
          );
          parts.forEach((part) => {
            const next = source.querySelector(`[data-listing-part="${part.dataset.listingPart}"]`);
            if (next) part.innerHTML = next.innerHTML;
          });
          this.sanitizeLinks();
          this.restoreState(state);
          this.setupInfinite();
        }

        captureState() {
          const active = document.activeElement;
          const scroll = {};
          this.querySelectorAll('[data-listing-scroll]').forEach((el) => {
            scroll[el.dataset.listingScroll] = el.scrollTop;
          });
          return {
            focusId: active && this.contains(active) ? active.id : '',
            groups: Array.from(this.querySelectorAll('[data-filter-group]')).map((group) => [
              group.dataset.filterGroup,
              group.classList.contains('is-open'),
            ]),
            expanded: Array.from(this.querySelectorAll('[data-filter-more][aria-expanded="true"]')).map((btn) =>
              btn.getAttribute('aria-controls'),
            ),
            searches: Array.from(this.querySelectorAll('[data-filter-search]'))
              .filter((input) => input.value)
              .map((input) => [input.closest('.sx-filter-group')?.dataset.filterGroup, input.value]),
            scroll,
          };
        }

        restoreState(state) {
          const groups = new Map(state.groups);
          this.querySelectorAll('[data-filter-group]').forEach((group) => {
            if (groups.has(group.dataset.filterGroup)) this.setGroup(group, groups.get(group.dataset.filterGroup));
          });
          state.expanded.forEach((id) => {
            this.querySelector(`[data-filter-more][aria-controls="${CSS.escape(id)}"]`)?.setAttribute('aria-expanded', 'true');
          });
          state.searches.forEach(([key, value]) => {
            const input = this.querySelector(`[data-filter-group="${CSS.escape(key || '')}"] [data-filter-search]`);
            if (input) input.value = value;
          });
          this.querySelectorAll('[data-filter-values]').forEach((wrap) => this.refreshValues(wrap));
          this.querySelectorAll('[data-listing-scroll]').forEach((el) => {
            const top = state.scroll[el.dataset.listingScroll];
            if (typeof top === 'number') el.scrollTop = top;
          });
          const focusLost = !document.activeElement || document.activeElement === document.body || !this.contains(document.activeElement);
          if (state.focusId && focusLost) {
            document.getElementById(state.focusId)?.focus({ preventScroll: true });
          }
        }

        sanitizeLinks() {
          this.querySelectorAll('a[href*="section_id="]').forEach((link) => {
            const url = new URL(link.href, window.location.href);
            url.searchParams.delete('section_id');
            link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
          });
        }

        scrollToTop() {
          const top = this.closest('.sx-section') || this;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          top.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        }

        /* ---------- Load more / infinite ---------- */
        async loadMore(link) {
          if (this.loadingMore) return;
          this.loadingMore = true;
          link.setAttribute('aria-busy', 'true');
          const spinner = link.querySelector('.sx-spinner');
          if (spinner) spinner.hidden = false;
          const nextUrl = new URL(link.href, window.location.href);
          try {
            const html = await this.fetchSection(nextUrl.search.slice(1));
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const source = doc.querySelector('sx-listing');
            const grid = this.querySelector('[data-listing-grid]');
            if (!source || !grid) throw new Error('Listing markup missing');

            const items = Array.from(source.querySelectorAll('[data-listing-grid] > li'));
            items.forEach((item) => grid.appendChild(document.adoptNode(item)));

            const more = this.querySelector('[data-listing-part="more"]');
            const nextMore = source.querySelector('[data-listing-part="more"]');
            if (more && nextMore) more.innerHTML = nextMore.innerHTML;
            this.sanitizeLinks();

            const nextButton = this.querySelector('a[data-listing-more]');
            if (this.mode !== 'infinite') {
              const focusTarget = nextButton || items[0]?.querySelector('a[href]');
              focusTarget?.focus({ preventScroll: true });
            }
            this.setupInfinite();
          } catch (error) {
            nextUrl.searchParams.delete('section_id');
            window.location.assign(nextUrl.toString());
          } finally {
            this.loadingMore = false;
            if (link.isConnected) {
              link.removeAttribute('aria-busy');
              if (spinner) spinner.hidden = true;
            }
          }
        }

        setupInfinite() {
          this.observer?.disconnect();
          if (this.mode !== 'infinite' || !('IntersectionObserver' in window)) return;
          const sentinel = this.querySelector('[data-listing-sentinel]');
          if (!sentinel) return;
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              const link = sentinel.querySelector('a[data-listing-more]');
              if (link) this.loadMore(link);
            },
            { rootMargin: '600px 0px' },
          );
          this.observer.observe(sentinel);
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-quantity')) {
    customElements.define(
      'sx-quantity',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input');
          this.buttons = this.querySelectorAll('[data-step]');
          this.buttons.forEach((button) => button.addEventListener('click', () => this.step(Number(button.dataset.step))));
          this.input.addEventListener('change', () => this.clamp());
          this.syncButtons();
        }

        get min() {
          return Number(this.input.min || 1);
        }

        get max() {
          return this.input.max ? Number(this.input.max) : Infinity;
        }

        setValue(next, notify = true) {
          const value = Math.min(this.max, Math.max(this.min, Math.floor(Number(next) || this.min)));
          const changed = String(value) !== this.input.value;
          this.input.value = value;
          this.syncButtons();
          if (changed && notify) this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        step(delta) {
          this.setValue(Number(this.input.value) + delta);
        }

        clamp() {
          const value = Math.min(this.max, Math.max(this.min, Math.floor(Number(this.input.value) || this.min)));
          if (String(value) !== this.input.value) this.input.value = value;
          this.syncButtons();
        }

        syncButtons() {
          const value = Number(this.input.value);
          this.buttons[0].disabled = value <= this.min;
          this.buttons[1].disabled = value >= this.max;
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-quick-add-host')) {
    customElements.define(
      'sx-quick-add-host',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.drawer = this.querySelector('sx-drawer');
          this.body = this.querySelector('[data-qa-body]');
          if (!this.drawer || !this.body) return;

          this.onClick = (event) => {
            const trigger = event.target.closest('[data-quick-add]');
            if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
            const url = trigger.dataset.quickAdd || trigger.getAttribute('href');
            if (!url) return;
            event.preventDefault();
            this.load(url, trigger);
          };
          document.addEventListener('click', this.onClick);

          /* Added from the sheet: hand over to the cart sheet rather than stacking two overlays. */
          this.addEventListener('sx:quick-add-done', () => {
            this.drawer.close();
            window.setTimeout(() => window.SxTheme.cart.afterAdd(), 220);
          });
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onClick);
          this.bound = false;
        }

        async load(url, trigger) {
          this.token = (this.token || 0) + 1;
          const token = this.token;
          this.body.innerHTML = '<div class="qa-host__loading"><span class="qa-host__spinner" aria-hidden="true"></span></div>';
          this.drawer.open(trigger);
          const target = new URL(url, window.location.origin);
          target.searchParams.set('section_id', 'quick-add');
          try {
            const response = await fetch(target.toString(), { headers: { Accept: 'text/html' } });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const html = await response.text();
            if (token !== this.token) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const card = doc.querySelector('sx-quick-add-form');
            if (!card) throw new Error('empty');
            /* DOMParser documents have no custom element registry, so an adopted node stays
               un-upgraded. Re-parsing the markup in this document runs the definitions. */
            this.body.innerHTML = card.outerHTML;
          } catch (error) {
            if (token !== this.token) return;
            const fallback = document.createElement('p');
            fallback.className = 'qa-host__error';
            fallback.textContent = window.SxTheme?.strings?.cartError || '';
            const link = document.createElement('a');
            link.className = 'qa__details';
            link.href = url;
            link.textContent = window.SxTheme?.strings?.quickAddDetails || '';
            this.body.replaceChildren(fallback, link);
          }
        }
      },
    );
  }

  if (!customElements.get('sx-quick-add-form')) {
    customElements.define(
      'sx-quick-add-form',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          const data = this.querySelector('[data-qa-variants]');
          try {
            this.variants = JSON.parse(data ? data.textContent : '[]');
          } catch (error) {
            this.variants = [];
          }
          this.groups = Array.from(this.querySelectorAll('[data-qa-option]'));
          this.atc = this.querySelector('[data-qa-atc]');
          this.atcLabel = this.querySelector('[data-qa-atc-label]');
          this.error = this.querySelector('[data-qa-error]');
          this.perso = this.querySelector('[data-qa-perso]');
          this.unitsWrap = this.querySelector('[data-qa-units]');
          this.quantity = this.querySelector('[name="qa-quantity"]');
          /* A set SKU (parca-N tag) is already N engraved pieces per unit, so one unit of quantity
             asks for N messages and they travel as N properties on the same cart line. */
          this.pieces = Math.max(1, Number(this.perso?.dataset.pieces) || 1);
          if (this.unitsWrap) this.unitTemplate = this.unitsWrap.querySelector('[data-qa-unit]').cloneNode(true);

          this.addEventListener('click', (event) => {
            const option = event.target.closest('[data-qa-value]');
            if (option) this.pick(option);
            else if (event.target.closest('[data-qa-atc]')) this.add();
          });
          this.addEventListener('change', (event) => {
            if (event.target.closest('[data-qa-select]')) this.sync();
            else if (event.target === this.quantity) this.setUnits(this.quantity.value);
          });
          this.addEventListener('input', (event) => {
            const input = event.target.closest('[data-qa-perso-input]');
            if (input) this.onPersoInput(input);
            else if (event.target === this.quantity) this.setUnits(this.quantity.value);
          });

          this.setUnits(this.quantity ? this.quantity.value : 1);
          this.sync();
        }

        units() {
          return this.unitsWrap ? Array.from(this.unitsWrap.querySelectorAll('[data-qa-unit]')) : [];
        }

        /* One message field per piece, capped so a large quantity does not explode into a wall of
           inputs — anything beyond the cap ships with the last message. */
        setUnits(quantity) {
          if (!this.unitsWrap || !this.unitTemplate) return;
          const cap = Number(this.perso.dataset.maxUnits) || 5;
          const asked = (Number(quantity) || 1) * this.pieces;
          const wanted = Math.max(1, Math.min(asked, cap));
          const units = this.units();
          for (let i = units.length; i < wanted; i += 1) {
            const unit = this.unitTemplate.cloneNode(true);
            const input = unit.querySelector('[data-qa-perso-input]');
            const label = unit.querySelector('[data-qa-unit-label]');
            input.id = `qa-perso-input-${i + 1}`;
            input.value = '';
            input.removeAttribute('aria-invalid');
            if (label) label.htmlFor = input.id;
            const preview = unit.querySelector('[data-qa-preview]');
            if (preview) {
              preview.textContent = '';
              preview.hidden = true;
            }
            this.unitsWrap.appendChild(unit);
          }
          units.slice(wanted).forEach((unit) => unit.remove());

          const template = this.perso.dataset.unitLabel || '';
          const multi = wanted > 1;
          this.units().forEach((unit, index) => {
            const label = unit.querySelector('[data-qa-unit-label]');
            if (!label) return;
            label.hidden = !multi;
            label.textContent = multi ? template.replace('[index]', String(index + 1)) : '';
          });
        }

        messages() {
          const theme = window.SxTheme;
          return this.units().map((unit) => {
            const input = unit.querySelector('[data-qa-perso-input]');
            const message = theme.morse.clean(input.value).trim();
            return { input, message, code: theme.morse.encode(message) };
          });
        }

        pick(button) {
          const group = button.closest('[data-qa-option]');
          group.querySelectorAll('[data-qa-value]').forEach((el) => {
            const active = el === button;
            el.classList.toggle('is-selected', active);
            el.setAttribute('aria-checked', String(active));
            el.tabIndex = active ? 0 : -1;
          });
          this.sync();
        }

        selection() {
          return this.groups
            .filter((group) => group.querySelector('[data-qa-value], [data-qa-select]'))
            .map((group) => {
              const select = group.querySelector('[data-qa-select]');
              if (select) return select.value;
              const active = group.querySelector('[data-qa-value].is-selected');
              return active ? active.dataset.qaValue : null;
            });
        }

        sync() {
          const chosen = this.selection();
          this.groups.forEach((group, index) => {
            const name = group.querySelector('[data-qa-option-name]');
            if (name) name.textContent = `: ${chosen[index] || ''}`;
          });
          this.variant = chosen.length
            ? this.variants.find((item) => chosen.every((value, index) => item.options[index] === value))
            : this.variants[0];
          this.renderVariant();
        }

        renderVariant() {
          const theme = window.SxTheme;
          const price = this.querySelector('[data-qa-price] .sx-price__final');
          const compare = this.querySelector('[data-qa-price] .sx-price__compare');
          if (price && this.variant) price.textContent = theme.formatMoney(this.variant.price);
          if (compare) {
            const show = Boolean(this.variant && this.variant.compare_at_price > this.variant.price);
            compare.hidden = !show;
            if (show) compare.textContent = theme.formatMoney(this.variant.compare_at_price);
          }
          const image = this.querySelector('[data-qa-media] img');
          if (image && this.variant?.featured_image?.src) {
            const src = new URL(this.variant.featured_image.src, window.location.origin);
            src.searchParams.set('width', '320');
            image.src = src.toString();
          }
          const available = Boolean(this.variant && this.variant.available);
          if (!this.atc) return;
          this.atc.disabled = !available;
          if (!this.atcLabel) return;
          if (!this.variant) this.atcLabel.textContent = this.dataset.unavailableText;
          else this.atcLabel.textContent = available ? this.dataset.addText : this.dataset.soldOutText;
        }

        onPersoInput(input) {
          const theme = window.SxTheme;
          const clean = theme.morse.clean(input.value).slice(0, Number(input.maxLength) || 12);
          if (clean !== input.value) input.value = clean;
          if (clean.trim()) {
            input.removeAttribute('aria-invalid');
            this.setError('');
          }
          const preview = input.closest('[data-qa-unit]')?.querySelector('[data-qa-preview]');
          if (!preview) return;
          const code = theme.morse.encode(clean);
          preview.textContent = code;
          preview.hidden = !code;
        }

        setError(message) {
          if (!this.error) return;
          this.error.textContent = message;
          this.error.hidden = !message;
        }

        /* Pieces with different messages have to be separate cart lines; identical ones merge so the
           quantity stays honest and quantity-based discounts still see the full product total.
           A set SKU is the exception: its pieces live inside one line, as numbered properties. */
        lineItems(quantity) {
          const property = this.dataset.property;
          const codeProperty = this.dataset.codeProperty;
          const units = this.messages();
          if (!this.perso || !property) return [{ id: this.variant.id, quantity }];

          if (this.pieces > 1) {
            const lines = [];
            for (let set = 0; set < quantity; set += 1) {
              const properties = {};
              for (let piece = 0; piece < this.pieces; piece += 1) {
                const unit = units[Math.min(set * this.pieces + piece, units.length - 1)];
                const suffix = piece === 0 ? '' : ` ${piece + 1}`;
                properties[property + suffix] = unit.message;
                if (codeProperty) properties[codeProperty + suffix] = unit.code;
              }
              lines.push({ id: this.variant.id, quantity: 1, properties });
            }
            return lines;
          }

          const groups = new Map();
          units.forEach(({ message, code }, index) => {
            const entry = groups.get(message) || { message, code, quantity: 0 };
            entry.quantity += 1;
            groups.set(message, entry);
            if (index === units.length - 1 && quantity > units.length) entry.quantity += quantity - units.length;
          });
          return Array.from(groups.values()).map(({ message, code, quantity: qty }) => {
            const properties = { [property]: message };
            if (codeProperty) properties[codeProperty] = code;
            return { id: this.variant.id, quantity: qty, properties };
          });
        }

        async add() {
          const theme = window.SxTheme;
          if (!this.variant || !this.variant.available) return;
          if (this.perso) {
            const missing = this.messages().find(({ message }) => !message);
            if (missing) {
              missing.input.setAttribute('aria-invalid', 'true');
              this.setError(this.dataset.requiredText);
              missing.input.focus();
              return;
            }
          }
          this.setError('');
          const label = this.atcLabel ? this.atcLabel.textContent : '';
          this.atc.setAttribute('aria-busy', 'true');
          this.atc.disabled = true;
          if (this.atcLabel) this.atcLabel.textContent = this.dataset.addingText;
          try {
            const quantity = Math.max(1, Number(this.quantity?.value) || 1);
            await theme.cart.add(this.lineItems(quantity));
            this.dispatchEvent(new CustomEvent('sx:quick-add-done', { bubbles: true }));
          } catch (failure) {
            this.setError(failure.data?.description || failure.data?.message || this.dataset.errorText);
            if (this.atcLabel) this.atcLabel.textContent = label;
          } finally {
            if (this.isConnected) {
              this.atc.removeAttribute('aria-busy');
              this.atc.disabled = false;
            }
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["slider-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-slider')) {
    const EDGE = 2;

    customElements.define(
      'sx-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.sx-slider__track');
          this.arrows = this.querySelector('[data-slider-arrows]');
          if (!this.track || !this.arrows) return;
          this.prev = this.arrows.querySelector('[data-slider-prev]');
          this.next = this.arrows.querySelector('[data-slider-next]');
          this.abort = new AbortController();
          const { signal } = this.abort;
          this.update = this.update.bind(this);
          this.prev.addEventListener('click', () => this.page(-1), { signal });
          this.next.addEventListener('click', () => this.page(1), { signal });
          this.track.addEventListener('scroll', this.update, { passive: true, signal });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
        }

        update() {
          const track = this.track;
          const max = track.scrollWidth - track.clientWidth;
          this.arrows.hidden = max <= EDGE;
          this.prev.disabled = track.scrollLeft <= EDGE;
          this.next.disabled = track.scrollLeft >= max - EDGE;
        }

        page(direction) {
          this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["track-arrows"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-track-arrows')) {
    const EDGE_TOLERANCE = 2;

    customElements.define(
      'sx-track-arrows',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.closest('.sx-section')?.querySelector('.sx-slider__track');
          if (!this.track) return;
          this.prev = this.querySelector('[data-track-prev]');
          this.next = this.querySelector('[data-track-next]');
          this.abort = new AbortController();
          const { signal } = this.abort;
          this.update = this.update.bind(this);
          this.prev.addEventListener('click', () => this.page(-1), { signal });
          this.next.addEventListener('click', () => this.page(1), { signal });
          this.track.addEventListener('scroll', this.update, { passive: true, signal });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          this.abort?.abort();
          this.resizeObserver?.disconnect();
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.hidden = max <= EDGE_TOLERANCE;
          this.prev.disabled = this.track.scrollLeft <= EDGE_TOLERANCE;
          this.next.disabled = this.track.scrollLeft >= max - EDGE_TOLERANCE;
        }

        page(direction) {
          this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
